var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(1.236 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-1.236 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M43.572,3,27.8,30.311l12.517,7.227-.962-3.59,3.59-.962-2.1-4.248,3.59-.962-2.1-4.247,3.59-.962-2.1-4.247,3.59-.962-.962-3.59,3.59-.962L50.4,6.942Z",
    transform: "translate(9.206 -3)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M42.341,23.53l.4-.108a6.557,6.557,0,0,1-1.142-8l5.872-10.17L43.568,3,27.8,30.311l12.517,7.227-.954-3.59,3.59-.963-2.1-4.247,3.59-.962Z",
    transform: "translate(9.259 -3)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(0 12.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M0,0H14.454V13.14H0Z",
    transform: "translate(7.432 11.033) rotate(-45)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5154",
    "data-name": "Path 5154",
    d: "M0,0H5.256V13.14H0Z",
    transform: "translate(0 18.464) rotate(-45)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5155",
    "data-name": "Path 5155",
    d: "M0,0H5.256V7.884H0Z",
    transform: "translate(5.574 16.606) rotate(-45)",
    fill: "#656b76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5156",
    "data-name": "Path 5156",
    d: "M29.929,10.741l-.085.024a9.111,9.111,0,0,0-6.4,6.4l-.024.085L17.849,11.67A9.115,9.115,0,0,1,28.371,9.962Z",
    transform: "translate(1.666 -8.999)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5157",
    "data-name": "Path 5157",
    d: "M0,0H7.884V26.28H0Z",
    transform: "translate(19.508 17.537) rotate(-45)",
    fill: "#57b7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(0.003 0.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5158",
    "data-name": "Path 5158",
    d: "M21.664,18.564a5.256,5.256,0,0,1-7.433,0l-2.946-2.942L8.657,18.25l9.291,9.291,10.22-10.22-2.628-2.628Z",
    transform: "translate(-1.224 -7.654)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5159",
    "data-name": "Path 5159",
    d: "M9.5,27.239l-5.19-5.186L3,23.367l9.291,9.291,3.717-3.711-1.353-1.359A3.93,3.93,0,0,1,9.5,27.239Z",
    transform: "translate(-3 -5.343)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5160",
    "data-name": "Path 5160",
    d: "M27.084,9.336a9.131,9.131,0,0,0-2.407,2.436,2.336,2.336,0,0,1-3.615.377L19.315,10.4a9.056,9.056,0,0,0-1.466,1.162l5.575,5.575.022-.085a9.115,9.115,0,0,1,6.4-6.4l.085-.024-1.557-.778a9.144,9.144,0,0,0-1.288-.522Z",
    transform: "translate(1.663 -9.336)",
    fill: "#93999a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5161",
    "data-name": "Path 5161",
    d: "M27.553,22.233,25.887,23.9a1.811,1.811,0,0,1-2.561-2.562l1.665-1.66L23.424,18.1l-5.575,5.575L36.432,42.262l5.575-5.575Z",
    transform: "translate(1.666 -6.142)",
    fill: "#4891d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(43.474 12.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5162",
    "data-name": "Path 5162",
    d: "M0,0H7.884V28.908H0Z",
    transform: "translate(20.438 10.502) rotate(45)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5163",
    "data-name": "Path 5163",
    d: "M49.218,22.082l-6.457,6.462a10.311,10.311,0,0,0,.77.863,10.462,10.462,0,0,0,6.483,3.034l6.2-6.211-1.971-1.971-1.427,1.427Z",
    transform: "translate(-30.205 -10.145)",
    fill: "#656b76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M65.192,19.408l-7.817,7.817L51.8,21.649l7.817-7.817a10.512,10.512,0,1,0,5.575,5.575Z",
    transform: "translate(-29.501 -12.998)",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5165",
    "data-name": "Path 5165",
    d: "M64.265,24.389a10.5,10.5,0,0,1-17.936-7.266A10.5,10.5,0,1,0,66,22.068,10.41,10.41,0,0,1,64.265,24.389Z",
    transform: "translate(-29.503 -11.702)",
    fill: "#93999a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5166",
    "data-name": "Path 5166",
    d: "M67.281,74.9H11.208a5.1,5.1,0,0,1-4.458-2.673,5.378,5.378,0,0,1,.076-5.3L34.864,19.274a5.05,5.05,0,0,1,8.763,0L71.663,66.926a5.378,5.378,0,0,1,.076,5.3A5.1,5.1,0,0,1,67.281,74.9Z",
    transform: "translate(3.537 -0.899)",
    fill: "#fcbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M67.85,60.445H54.6A15.566,15.566,0,0,1,39.245,44.677V16.735a5.048,5.048,0,0,0-4.381,2.539L6.827,66.926a5.378,5.378,0,0,0-.076,5.3A5.1,5.1,0,0,0,11.208,74.9H67.281a5.1,5.1,0,0,0,4.458-2.673,5.378,5.378,0,0,0-.076-5.3Z",
    transform: "translate(3.537 -0.899)",
    fill: "#fcbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5168",
    "data-name": "Path 5168",
    d: "M32.891,52.652a2.778,2.778,0,0,1-2.774-2.628l-.95-17.082a3.73,3.73,0,1,1,7.448,0l-.95,17.082A2.778,2.778,0,0,1,32.891,52.652Z",
    transform: "translate(9.824 3.726)",
    fill: "#cc5144"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 2.628,
    cy: 2.628,
    r: 2.628,
    transform: "translate(40.089 60.86)",
    fill: "#cc5144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M30.117,50.024a2.778,2.778,0,0,0,5.548,0l.014-.263a15.679,15.679,0,0,1-2.788-8.935V29a3.73,3.73,0,0,0-3.724,3.942Z",
    transform: "translate(9.836 3.726)",
    fill: "#cc5144"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMaintain);
export default __webpack_public_path__ + "static/media/img_maintain.5fa50f02d818fd787a8f9dfa911b2000.svg";
export { ForwardRef as ReactComponent };